import { pickBy } from 'lodash-es';
import { getMsftReferral_mappedFields_Response } from 'packages/tackle-api/src/data-mapper/getMsftReferralMappedFields';

export const MsftReferral_Create_MappedFields_Response_TransformSchema =
  getMsftReferral_mappedFields_Response.transform((input) => {
    const values = input.mappedFields?.referralInput ?? {};
    const customerLookupInput = input.mappedFields?.customerLookupInput ?? {};
    const solutionLookupIds = input.mappedFields?.solutionLookupIds ?? [];

    return {
      '$tkl-metadata': input['$tkl-metadata'],
      fieldsWithErrors: input?.errors
        ? !!Object.keys(input.errors)?.length
        : false,

      initialValues: pickBy(
        {
          campaignId: values.campaignId,
          customerProfile: values.customerProfile,
          name: values.name,
          team: values.team,
          typeOfHelp: values.inviteContexts?.[0],
          details: values.details,
          mpnId: values.mpnId,
        },
        (value) => value != null,
      ),
      customerLookupInput,
      solutionLookupIds,
    };
  });
